import React from 'react'
import { useScreenSize } from '@navent-jobs/ui-kit/hooks/screen-size'
import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { Button } from '@navent-jobs/ui-kit/components/button'
import { EcommerceDataLayers } from '../../../../constants/gtm-events/gtm-events-ecommerce'
import { AvisosListadoDataLayers } from '../../../../constants/gtm-events/gtm-events-avisos-listado'

const Component = () => {
  const location = useLocation()
  const { isDesktop } = useScreenSize()
  const isEcommerce = useMemo(() => location.pathname.startsWith('/empresas/ecommerce/formpago'), [location.pathname])
  const isListing = useMemo(() => location.pathname.startsWith('/empresas/avisos/listado'), [location.pathname])
  const isTkp = useMemo(() => location.pathname.startsWith('/empresas/aviso/thankyou'), [location.pathname])
  const isTkpProductos = useMemo(
    () => location.pathname.startsWith('/empresas/aviso/productos/thankyou'),
    [location.pathname]
  )
  const isRecomendados = useMemo(() => location.pathname.startsWith('/empresas/recomendados'), [location.pathname])
  const prevUrl = location.state?.from
  const prevUrlMP = prevUrl === '/empresas/mercadoPago'
  const urlDashboard = '/empresas/inicio'
  const onClick = () => {
    if (isEcommerce) EcommerceDataLayers.CtaDatosPersonales('Atras')
    if (isListing) AvisosListadoDataLayers.atrasClick()
    if (isTkp || isTkpProductos) {
      window.location.assign('/empresas/avisos/listado')
      return
    }
    if (prevUrlMP || isRecomendados) {
      window.location.assign(urlDashboard)
      return
    }

    if (document.referrer) {
      window.history.back()
    } else {
      window.location.assign(urlDashboard)
    }
  }

  return (
    <Button
      onClick={onClick}
      icon={{ name: 'icon-light-arrow-left', size: isDesktop ? '32' : '20' }}
      buttonoptions={{
        type: 'link',
        variant: 'secondary',
      }}
    />
  )
}

export default Component
